;
(function(window, document, $, undefined) {
    $(function(){

        var swiperContainer = $("#swiper-container");
        var liList = swiperContainer.find("li");
        var liLength = liList.length;


        var index = 0;

        $("#nav_left").on('click',function(e) {
            if(index == 0) return false;

            liList.eq(index - 1).css('display', 'block');
            liList.eq(index + 3).css('display', 'none');
            index--;

            e.stopPropagation();
        });

        $("#nav_right").on('click', function(e) {
            if(index == (liLength - 4)) return false;

            liList.eq(index).css('display', 'none');
            liList.eq(index + 4).css('display', 'block');
            index++;

            e.stopPropagation();
        });

       /* $("#returntop").on('click', function(e){
             $('body,html').animate({scrollTop:0},1000);

             e.stopPropagation();
        });
*/

        $(document).on('click','[data-handle="show"]',function(e) {
            var self = $(this);
            var curr = self.data('target');

            self.siblings().each(function(idx, item) {
                var currIcon = $(item);
                if(currIcon.hasClass('active')) {
                    currIcon.addClass('move-over').removeClass('active');
                    return false;
                }
            });

            self.removeClass('move-over').addClass('active');

            $(document).find('[data-handle="showorhide"]').each(function(idx, item) {
                var currItem = $(item);
                if(currItem.data('target') == curr) {
                    currItem.css('display', 'block');
                }
                else {
                    currItem.css('display', 'none');
                }
            });

            e.stopPropagation();
        });

        function parseQueryString () {
            var params = {};
            var parts = window.location.search.substr(1).split('\x26');

            for (var i = 0; i < parts.length; i++) {
                var keyValuePair = parts[i].split('=');
                var key = decodeURIComponent(keyValuePair[0]);
                var value = keyValuePair[1] ?
                    decodeURIComponent(keyValuePair[1].replace(/\+/g, ' ')) :
                    keyValuePair[1];

                switch (typeof(params[key])) {
                    case 'undefined':
                        params[key] = value;
                        break; //first
                    case 'array':
                        params[key].push(value);
                        break; //third or more
                    default:
                        params[key] = [params[key], value]; // second
                }
            }
            return params;
        };

        var _getParam = parseQueryString();

        if(_getParam.type){
            $('#swiper-container').find('[data-target="'+ _getParam.type +'"]').trigger('click');
        }


    });
})(window, document, jQuery);

function goTop()
{
    $(window).scroll(function(e) {
        //若滚动条离顶部大于100元素
        if($(window).scrollTop()>100)
            $("#returntop").fadeIn("slow");//以1秒的间隔渐显id=gotop的元素
        else
            $("#returntop").fadeOut("slow");//以1秒的间隔渐隐id=gotop的元素
    });
};
$(function(){
	$("#returntop").hide();
    //点击回到顶部的元素
    $("#returntop").click(function(e) {
            //以1秒的间隔返回顶部
            $('body,html').animate({scrollTop:0},1000);
    });

    goTop();//实现回到顶部元素的渐显与渐隐
});